module.exports = __webpack_public_path__ + "img/ocean-hotel-6.7e1e84b4.jpg";